import { defineSlotRecipe } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/react/anatomy';

export const switchRecipe = defineSlotRecipe({
  className: 'ac-switch',
  slots: switchAnatomy.keys(),
  base: {
    root: {
      display: 'flex',
      flexDir: 'row',
      justifyContent: 'space-between',

      alignItems: 'center',
      gap: '15px',
      cursor: 'pointer',

      width: 'auto',

      _disabled: {
        cursor: 'disabled',
      },
    },
    label: {
      color: 'grey.dark.2',
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.15px',
    },
    control: {
      display: 'inline-block',
      backgroundColor: 'grey.light.1',
      position: 'relative',
      transitionProperty: 'background',
      transitionDuration: 'moderate',
      transitionTimingFunction: 'ease-in-out',

      _disabled: {
        backgroundColor: 'grey.light.0',
      },

      _checked: {
        backgroundColor: 'halton.green',

        _disabled: {
          backgroundColor: 'halton.green/20',
        },
      },
    },
    thumb: {
      borderRadius: '50%',
      display: 'block',
      position: 'absolute',
      backgroundColor: 'white',

      transitionProperty: 'left',
      transitionDuration: 'moderate',
      transitionTimingFunction: 'ease-in-out',
    },
  },
  variants: {
    size: {
      xs: {
        root: {
          gap: '8px',
        },
        control: {
          minW: '40px',
          width: '40px',
          height: '24px',
          borderRadius: '12px',
        },
        thumb: {
          width: '18px',
          height: '18px',
          top: '3px',
          left: '3px',

          _checked: {
            left: 'calc(40px - 18px - 3px)',
          },
        },
      },
      sm: {
        root: {
          gap: '10px',
        },
        control: {
          minW: '60px',
          width: '60px',
          height: '32px',
          borderRadius: '16px',
        },
        thumb: {
          width: '24px',
          height: '24px',
          top: '4px',
          left: '4px',

          _checked: {
            left: '32px',
          },
        },
      },
      md: {
        root: {
          gap: '15px',
        },
        control: {
          minW: '80px',
          width: '80px',
          height: '40px',
          borderRadius: '20px',
        },
        thumb: {
          width: '30px',
          height: '30px',
          top: '5px',
          left: '5px',

          _checked: {
            left: '45px',
          },
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
});
